import { i18nService } from '@zonofi/i18n';

let ERROR_MESSAGES: Record<string, string> = {};

/**
 * Initialize error messages after i18nService is ready
 */
const initErrorMessages = () => {
  ERROR_MESSAGES = {
    REQUIRED: i18nService.t('errors:ERR_MSG_REQUIRED'),
    DIGITS_ONLY: i18nService.t('errors:ERR_MSG_DIGITS_ONLY'),
    ALPHA_NUMERIC: i18nService.t('errors:ERR_MSG_ALPHA_NUMERIC'),
    TEXT_INPUT: i18nService.t('errors:ERR_MSG_TEXT_INPUT'),
    MOBILE: i18nService.t('errors:ERR_MSG_MOBILE'),
    EMAIL: i18nService.t('errors:ERR_MSG_EMAIL'),
    EMAIL_OR_MOBILE: i18nService.t('errors:ERR_MSG_EMAIL_OR_MOBILE'),
    NAME: i18nService.t('errors:ERR_MSG_NAME'),
    MIN_NAME_LENGTH: i18nService.t('errors:ERR_MSG_MIN_NAME_LENGTH'),
    AMOUNT: i18nService.t('errors:ERR_MSG_AMOUNT'),
    DATE: i18nService.t('errors:ERR_MSG_DATE'),
    GSTIN: i18nService.t('errors:ERR_MSG_GSTIN'),
    PAN: i18nService.t('errors:ERR_MSG_PAN'),
    AADHAR: i18nService.t('errors:ERR_MSG_AADHAR'),
    PINCODE: i18nService.t('errors:ERR_MSG_PINCODE'),
    BANK_ACCOUNT: i18nService.t('errors:ERR_MSG_BANK_ACCOUNT'),
    IFSC: i18nService.t('errors:ERR_MSG_IFSC'),
    CHEQUE: i18nService.t('errors:ERR_MSG_CHEQUE'),
    VEHICLE: i18nService.t('errors:ERR_MSG_VEHICLE'),
  };
};

// Initialize once i18nService is ready
if (i18nService.isInitialized()) {
  initErrorMessages();
} else {
  // Optionally, subscribe to initialization
  const unsubscribe = i18nService.onChange(() => {
    if (i18nService.isInitialized()) {
      initErrorMessages();
      unsubscribe(); // remove listener after init
    }
  });
}

export { ERROR_MESSAGES };
